import React, { FC, useState, MouseEvent } from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import Button from 'shared/components/andtComponents/Button';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';
import { copyStrToClipboard } from 'shared/utils/strUtil';
import styles from './TagsPopover.module.scss';
import { TagsPopoverProps } from '../../types';

const CopyIcon = ({ copied }: { copied: boolean }) => (
  <GenerateIcon iconName={copied ? ICONS.check.name : ICONS.copy.name} />
);

const GovernanceTagsPopover: FC<TagsPopoverProps> = ({ tags, children }) => {
  const [copied, setCopied] = useState(false);

  const getAllTagsText = () => tags.map((tag) => `${tag.name}: ${tag.value}`).join('\n');

  const handleCopy = (e: MouseEvent) => {
    e.stopPropagation();
    copyStrToClipboard(getAllTagsText());
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  return (
    <Tooltip
      placement="bottom"
      title={
        <div className={styles.tooltipContainer}>
          <div className={styles.copyButtonContainer}>
            <Button
              onClick={handleCopy}
              isTextButton
              text="Copy"
              automation-id="copy-tags-button"
              icon={() => <CopyIcon copied={copied} />}
            />
          </div>
          <div className={styles.tagsContainer}>
            {tags.map((tag) => (
              <div key={`${tag.name}-${tag.value}`} className={styles.tagItem}>
                <div className={styles.tagName}>{tag.name}</div>
                <div className={styles.tagValue}>{tag.value}</div>
              </div>
            ))}
          </div>
        </div>
      }
      classes={{ tooltip: tooltipStyles.whiteTooltip, arrow: tooltipStyles.whiteArrow }}
    >
      {children}
    </Tooltip>
  );
};

export default GovernanceTagsPopover;
